import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/routes";
import { Tweaks } from "./tweaks/Tweaks";
import { useTweaks } from "./tweaks/useTweaks";

export default function App() {
  const [tweaks, setTweaks] = useTweaks();

  // Phase 2 route shape: /projects/:id/step/:n.
  // Apply display scale via CSS variable so display-* utilities respond.
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--display-scale",
      String(tweaks.displayScale),
    );
  }, [tweaks.displayScale]);

  // 12-col grid overlay toggle (Tweaks).
  useEffect(() => {
    const cls = "grid-overlay";
    if (tweaks.showGrid) document.body.classList.add(cls);
    else document.body.classList.remove(cls);
    return () => document.body.classList.remove(cls);
  }, [tweaks.showGrid]);

  return (
    <>
      <RouterProvider router={router} />
      <Tweaks tweaks={tweaks} onChange={setTweaks} />
    </>
  );
}
